import styled, { AnyStyledComponent } from 'styled-components';

interface PropTypes {
  transitionDuration: number;
  easing: string;
};

export const ContentWrapper: AnyStyledComponent = styled.div`
  overflow: hidden;
  transition: ${(props: PropTypes) => (`height ${props.transitionDuration}s ${props.easing}`)};
`;
